import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import MobileHeader from "./MobileHeader";
import { useI18n } from "@/contexts/I18nContext";
import SetupProgressWidget from "@/components/provider/SetupProgressWidget";

export default function AppShell() {
    const { isRTL } = useI18n();
    const padClass = isRTL ? "md:pr-[280px]" : "md:pl-[280px]";
    return (
        <div className="min-h-screen bg-background" data-testid="app-shell">
            <Sidebar />
            <div className={`flex flex-col min-h-screen ${padClass}`}>
                <MobileHeader />
                <main className="flex-1 px-4 sm:px-6 lg:px-10 py-6 sm:py-8" data-testid="app-main">
                    <Outlet />
                </main>
            </div>
            <SetupProgressWidget />
        </div>
    );
}
